// extracted by mini-css-extract-plugin
export default {"tabs":"tabs-ZGepy","empty":"empty-r57O9","tabPanel":"tabPanel-YJeK1","tab":"tab-mHGsK","nested":"nested-wRZ8j"};